import { LiItem } from "@faire/help-center-self-serve/brand/instantAnswers/instantAnswersComponents/common/LiItem";
import retailerSettingsProfile from "@faire/web-api/routes/retailer/settings/profile";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import { Bold } from "@faire/web/ui/Typography/Span";
import React from "react";
export var ResetOrUpdatePasswordIA = function ResetOrUpdatePasswordIA() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "qQ6HjO",
    defaultMessage: [{
      "type": 0,
      "value": "Dispõe de duas opções para gerir a sua palavra-passe:"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(Bold, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "4bZNDG",
    defaultMessage: [{
      "type": 0,
      "value": "Reponha a palavra-passe, caso se tenha esquecido dela:"
    }]
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "1ShK6n",
    defaultMessage: [{
      "type": 0,
      "value": "Clique em "
    }, {
      "children": [{
        "type": 0,
        "value": "Iniciar sessão"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " no canto superior direito da página inicial"
    }],
    values: {
      BoldFormatting: BoldFormatting
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "A45LYr",
    defaultMessage: [{
      "type": 0,
      "value": "Introduza o endereço de e-mail e prima Enter"
    }]
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 3
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "yaYwDM",
    defaultMessage: [{
      "type": 0,
      "value": "Clique em "
    }, {
      "children": [{
        "type": 0,
        "value": "Esqueceu-se da palavra-passe? Reponha-a"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }],
    values: {
      BoldFormatting: BoldFormatting
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 4
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "3dToYM",
    defaultMessage: [{
      "type": 0,
      "value": "Consulte o e-mail (incluindo a pasta de spam) e procure uma ligação para repor a palavra-passe"
    }]
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 5
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "l36AqR",
    defaultMessage: [{
      "type": 0,
      "value": "Siga as instruções no e-mail para repor a sua palavra-passe"
    }]
  })))), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(Bold, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "Rp+OL4",
    defaultMessage: [{
      "type": 0,
      "value": "Atualize a palavra-passe, se souber a atual:"
    }]
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "3bw68g",
    defaultMessage: [{
      "type": 0,
      "value": "Aceda à página de "
    }, {
      "children": [{
        "type": 0,
        "value": "Definições"
      }],
      "type": 8,
      "value": "AccountSettingLinkFormatting"
    }],
    values: {
      AccountSettingLinkFormatting: AccountSettingLinkFormatting
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "Lv/yn9",
    defaultMessage: [{
      "type": 0,
      "value": "Aceda a "
    }, {
      "children": [{
        "type": 0,
        "value": "O meu perfil"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }],
    values: {
      BoldFormatting: BoldFormatting
    }
  })), " "), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 3
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "EaN/2z",
    defaultMessage: [{
      "type": 0,
      "value": "Encontre a secção "
    }, {
      "children": [{
        "type": 0,
        "value": "Palavra-passe"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " e siga as instruções para alterar a palavra-passe."
    }],
    values: {
      BoldFormatting: BoldFormatting
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "nUHkRv",
    defaultMessage: [{
      "type": 0,
      "value": "Se estiver a ter problemas em repor ou atualizar a sua palavra-passe, contacte-nos utilizando as opções abaixo."
    }]
  })));
};
var BoldFormatting = function BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};
var AccountSettingLinkFormatting = function AccountSettingLinkFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: retailerSettingsProfile(),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};